import {Home} from '@/layout';

export default {
    path: '/teacher',
    component: Home,
    meta: {
        roles: ['teacher'],
        childrenRoles: false
    },
    children: [
        {
            path: '',
            component: () => import('@/page/teacher'),
            children: [
                {
                    path: 'course',
                    meta: {
                        title: '开始上课'
                    },
                    component: () => import('@/page/manager/course')
                },
                {
                    path: 'classes',
                    meta: {
                        title: '我的班级学员'
                    },
                    component: () => import('@/page/teacher/MyClassStudents')
                },
            ]
        }
    ]
}
